export default __webpack_public_path__ + "icon-like-thumb.7b20f091.png";